<template>
  <div class="CrmMonthReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <div style="width: 250px" class="time-box flex-al fs14">
            <el-date-picker
              @change="search"
              v-model="filterList.rangeTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              @change="selectChannelSearch"
              size="small"
              style="width: 180px"
              v-model="filter.client_source"
              placeholder="请选择招生渠道类型"
            >
              <el-option
                v-for="item in filterList.SchoolsourceOption"
                :key="item.frommedia_id"
                :label="item.frommedia_name"
                :value="item.frommedia_name"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              size="small"
              @change="search"
              style="width: 180px"
              v-model="filter.channel_id"
              placeholder="请选择招生渠道明细"
            >
              <el-option
                v-for="item in filterList.ChannelOption"
                :key="item.channel_id"
                :label="item.channel_name"
                :value="item.channel_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              @change="search"
              size="small"
              style="width: 180px"
              v-model="filter.is_invite"
              placeholder="请选择是否邀约"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              @change="search"
              size="small"
              style="width: 180px"
              v-model="filter.is_invite_arrive"
              placeholder="请选择是否到访"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              @change="search"
              size="small"
              style="width: 180px"
              v-model="filter.client_tracestatus"
              placeholder="请选择名单状态"
            >
              <!-- 跟踪状态：0待跟踪1持续跟踪2已邀约3已试听4已转正-1已无意向-2无效名单', -->
              <!-- <el-option :label="$t('Common.options')" value></el-option> -->
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8frsw0')" value="0"></el-option>
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fs700')" value="1"></el-option>
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fss80')" value="2"></el-option>
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8ft6c0')" value="3"></el-option>
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fthw0')" value="4"></el-option>
              <el-option
                :label="$t('Customersmanage.bvN1')"
                value="6"
              ></el-option>
              <el-option
                :label="$t('Customersmanage.bvN2')"
                value="7"
              ></el-option>
              <el-option
                :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fttw0')"
                value="-1"
              ></el-option>
              <el-option
                :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fu5s0')"
                value="-2"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
import reportPageTemp from "@/components/report/reportTemp";
import http from "./analysisreport.js";

export default {
  name: "analysisreport-CrmMonthReport",
  data() {
    return {
      openMenu: ["8"],
      wayString: "schoolMothReport", //传递到子组件的方法名称
      Title: "招生咨询明细表",
      placehold: "", //传递到子组件的placehold

      reportParams: {
        wayString: "schoolMothReport", //传递到子组件的方法名称
        Title: "招生咨询明细表",
      },
      //筛选
      filter: {
        starttime: "",
        endtime: "",
        is_invite: "",
        is_invite_arrive: "",
        client_tracestatus: "",
        client_source: "",
        channel_id: "",
        keyword: "",
        coursetype_id: "", //班组
      },
      // 筛选的下拉列表
      filterList: {
        rangeTime: "",
        // 招生渠道类型
        SchoolsourceOption: [],
        ChannelOption: [], // 招生渠道明细
        sourceList: [], //选择渠道类型-下拉数据
        channelList: [], //选择渠道明细-下拉数据
        coursetypeList: [], //班组-下拉数据
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    PageNav,
    reportPageTemp,
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.getSourceData();
    this.getChannelData();
    this.filterList.rangeTime = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    (this.filter.starttime = this.$Common.getAppointedDate(2, 0).startDate),
      (this.filter.endtime = this.$Common.getAppointedDate(2, 0).endDate);
    this.courseTypeApi();
  },
  mounted() {},
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeApi() {
      http.courseTypeApi({}).then((res) => {
        if (res.data.code === 200) {
          this.filterList.coursetypeList = res.data.data.list;
        } else {
          this.filterList.coursetypeList = [];
        }
      });
    },
    //获取招生渠道类型
    getSourceData() {
      http.getSource({}).then((res) => {
        this.filterList.SchoolsourceOption = res.data.data.list;
      });
    },
    //获取招生渠道明细
    getChannelData() {
      http
        .getChannel({
          channel_medianame: this.filter.client_source,
        })
        .then((res) => {
          this.filterList.ChannelOption = res.data.data.list;
        });
    },
    // 数据检索
    selectChannelSearch() {
      this.filter.channel_id = "";
      this.getChannelData(); //获取招生渠道明细
      this.search();
    },
    search() {
      this.filter.starttime = this.filterList.rangeTime
        ? this.filterList.rangeTime[0]
        : "";
      this.filter.endtime = this.filterList.rangeTime
        ? this.filterList.rangeTime[1]
        : "";
      this.$refs["reportPageTemp"].search();
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("analysisreport.less");
.CrmMonthReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
